import React from "react";

const Button = props => <button {...props}>{props.children}</button>;

export default Button;
